import React, { memo } from "react";

import styles from "./../formSections.module.scss";

type BankTooltipContentProps = {
	data: [{ name: String; value: string }];
};

const BankTooltipContent = ({ data }: BankTooltipContentProps) => {
	return (
		<ul className={styles.tooltipFieldsList}>
			{data.map((item, index) => (
				<li key={index} className={styles.tooltipFieldRow}>
					<div className={styles.tooltipFieldLabel}>{item.name}</div>
					<div className={styles.tooltipFieldValue}>
						{item.value || "Not set"}
					</div>
				</li>
			))}
		</ul>
	);
};

export default memo(BankTooltipContent);
